import { Component, OnInit } from '@angular/core';
import { Utils } from '../utils/utils';
import { CSSMonitorService } from '../services/css-monitor.service';
import { Subscription } from 'rxjs';
import {PaperworkService} from '../services/paperwork.service';
import { TranslateService } from '@ngx-translate/core';

declare var $:any;

@Component({
    selector: 'go-footer',
    templateUrl: 'footer.component.html',
    standalone: false
})

export class FooterComponent implements OnInit {
  private subscription: Subscription = null;
  public cssDisabled:boolean = false;
  paperWorkMsg: String;

  constructor(
		private cssMonitorService: CSSMonitorService,
		private paperworkService: PaperworkService,
		private translate: TranslateService
	) { }

	ngOnInit(): void {
        this.cssMonitorService.start();
        this.subscription = this.cssMonitorService.styleChangeEvent.subscribe(
			(gotCss:string) => {
				if (gotCss === this.cssMonitorService.CSS_DISABLED) {
					this.handleCSSDisabled();
				} else {
					this.handleCSSEnabled();
				}
			}
		);

		//if language selection is changed, fetch relevant paper work reduction messages data.
		this.paperworkService.paperworkMessagesUpdatedSubj.subscribe(res => {
			this.paperworkService.getSysMessages().subscribe((res: any) => {
				let data = res[this.translate.currentLang];

				if (data) {
					this.paperWorkMsg = data['login.main'].PRA;
				}
			});
		});
	}

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

	sc() {
		Utils.scrollUp();
	}

  protected handleCSSDisabled() {
		this.cssDisabled = true;
		
	}

	protected handleCSSEnabled() {
		this.cssDisabled = false;
		//let elem = document.getElementById('someID');
		//$("#someID").css("list-style", "none");
	}

}
